module.exports = __webpack_public_path__ + "img/lookled.1ad28cef.jpg";